/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Directory_Ai_Tools_Studio_BalanceInputs */

const en_directory_ai_tools_studio_balance = /** @type {(inputs: Directory_Ai_Tools_Studio_BalanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Balance: ${i?.credits} credits`)
};

const zh_directory_ai_tools_studio_balance = /** @type {(inputs: Directory_Ai_Tools_Studio_BalanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`余额：${i?.credits} 积分`)
};

/**
* | output |
* | --- |
* | "Balance: {credits} credits" |
*
* @param {Directory_Ai_Tools_Studio_BalanceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_balance = /** @type {((inputs: Directory_Ai_Tools_Studio_BalanceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_BalanceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_balance(inputs)
	return zh_directory_ai_tools_studio_balance(inputs)
});
export { directory_ai_tools_studio_balance as "directory.ai_tools.studio.balance" }